module.exports = __webpack_public_path__ + "img/stroke-arrow.dd8f7bb1.png";